import {race, delay, take, put, select} from 'redux-saga/effects';
import {reject, get, moment, groupBy} from 'helpers';
import {decode} from './decode';
import {settings} from 'store/google-calendar';

export function* read() {
  while (true) {
    const { syncTokens, importCalendars, lastChangeTimestamp } = yield select(settings);

    for (const calendarId of importCalendars) {

      if (moment().valueOf() - lastChangeTimestamp < 1000) {
        //ignore this read because it was triggered by the change that the user just did in the web app
        continue;
      }

      const syncToken = get(syncTokens, calendarId);

      try {
        let { result: { items, nextSyncToken } } = yield window.gapi.client.calendar.events.list({
          calendarId,
          timeMin: syncToken ? null : moment().subtract(20, 'day').toISOString(),
          timeMax: syncToken ? null : moment().add(20, 'day').toISOString(),
          syncToken,
          singleEvents: false,
        });

        items = items.map(item => decode(item, calendarId));
        items = groupBy(items, item => item.activity_id ? 'progress' : 'events');

        yield put({
          type: 'GOOGLE_CALENDAR_DATA_RECEIVED',
          calendarId,
          nextSyncToken,
          events: [],
          progress: [],
          syncToken,
          ...items,
        });

      } catch (error) {
        error = get(error, 'result.error') || error;
        if (/sync token is no longer valid/i.test(error.message)) {
          yield put({
            type: 'GOOGLE_CALENDAR_REMOVE_SYNC_TOKEN',
            calendarId,
          });
        } else if (error.code == 404) {
          yield put({
            type: 'UI_SETTING',
            module: 'googleCalendar',
            key: 'importCalendars',
            value: reject(importCalendars, id => id == calendarId),
          });
        } else {
          throw new Error('Google Calendar: ' + error.message);
        }
      }

      yield delay(importCalendars.length > 1 ? 100 : 0);
    }

    //wait for 1 minute or socket message
    yield race({
      delay: delay(60*1000),
      force: take(['GOOGLE_CALENDAR_READ', 'GOOGLE_CALENDAR_FULL_READ']),
    });
  }
}
